import schema from 'storyblok-js-client/source/schema.js';

import { addLocalePrefix } from '@savebetter/components';
const richTextSchema = schema;
const isEmailLinkType = (type: string): boolean => type === 'email';
const fixEmailHref = ({ linktype, href }: { linktype: string; href: string }): string | undefined =>
  isEmailLinkType(linktype) ? `mailto:${href}` : addLocalePrefix(href);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
richTextSchema.marks.link = (node: any): any => {
  const attrs = {
    ...node.attrs,
    href: fixEmailHref(node.attrs),
    class: `font-medium no-underline border-b-2 border-primary text-primary hover:text-primary-80
      hover:border-primary-80 active:text-primary-100 active:border-primary-100 focus:sb-primary-shadow`
  };
  return {
    tag: [
      {
        tag: 'a',
        attrs
      }
    ]
  };
};

export default richTextSchema;
